'use client'

import type { ReactNode } from 'react'
import { PanelsSurfaceProvider, type PanelsSurface } from '@/deskUiSkeletons/Page/PanelsSurfaceContext'
import { mainTemplateVariant, menuTemplateVariant } from '@/stdDesk/rowTemplates/RowTemplateConfig'
import { MoreLink } from '@/deskUiSkeletons/Shared/Shared'
import { PagingBar } from '@/msgComponents/controls/PagingBar/Legacy/PagingBar'
import { RefreshSubs } from '@/msgComponents/controls/RefreshSubs/Legacy/RefreshSubs'
import { CheckedsInfo } from '@/msgComponents/controls/CheckedsInfo/Modern/CheckedsInfo'
import { FoldSubsButton } from '@/msgComponents/controls/FoldSubsButton/Legacy/FoldSubsButton'
import { panelsSkin } from './PanelsSkin'

// Std wiring for the shared panels skeleton: std picks its Legacy control
// visuals and supplies its variant config and skin through the seam.

const stdPanelsSurface: PanelsSurface = {
  FoldSubsButton,
  PagingBar,
  RefreshSubs,
  CheckedsInfo,
  MoreLink,
  menuEmptyLabel: 'No items',
  config: { mainTemplateVariant, menuTemplateVariant },
  skin: panelsSkin,
}

export function StdPanelsSurfaceProvider({ children }: { children: ReactNode }) {
  return <PanelsSurfaceProvider value={stdPanelsSurface}>{children}</PanelsSurfaceProvider>
}
